// @ts-ignore
// eslint-disable-next-line
function toggleBox() {
    const boxSections = document.querySelectorAll('.section-simplexnyc-grid--theme-light');

    if (boxSections.length === 0) {
        return;
    }

    boxSections.forEach(section => {
        const boxes = section.querySelectorAll('.section-simplexnyc-grid__box');

        function closeAllCards() {
            boxes.forEach(b => {
                b.classList.remove('active');
            });
        }

        boxes.forEach(box => {
            box.addEventListener('click', (e) => {
                if (box.classList.contains('active'))  {
                    box.classList.remove('active');
                } else {
                    closeAllCards();
                    box.classList.add('active');
                }

                e.stopPropagation();
            });
        });

        document.addEventListener('click', (e) => {
            closeAllCards();
        });
    });
}
toggleBox();